import { Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const subcategoriesOptions = [
  { name: "Cervejas",       param: "CERVEJA, Cerveja" },
  { name: "Microcervejarias", param: "Microcervejarias, microcervejarias, microcervejaria, Microcervejaria" },
  { name: "Vinhos",         param: "Vinho" },
  { name: "Destilados",     param: "DESTILADOS, VODKA, Gin" },
  { name: "Bebidas Mistas", param: "BEBIDAS MISTAS" },
  { name: "Chopp",          param: "CHOPP" },
  { name: "Kits",           param: "KITS" },
  { name: "Outras",         param: "OUTRAS BEBIDAS" },
  { name: "Não Alcoólicos", param: "Não alcoólicos" },
];

export function SubcategoryFilters(props) {
  const location = useLocation();
  const [subcategories, setSubcategories] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(active) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (active.length > 0) {
      url += `&subcategories=${active.join(',')}`;
    }
    const filter = new URLSearchParams(location.search).get("filter");
    if (filter) url += `&filter=${filter}`;
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggle(param) {
    const updated = subcategories.includes(param)
      ? subcategories.filter(s => s !== param)
      : [...subcategories, param];
    setSubcategories(updated);
    filterProducts(updated);
  }

  return (
    <>
      <Text fontSize="11px" fontWeight="800" color="rgba(0,74,51,0.55)" letterSpacing="0.08em" textTransform="uppercase" mb="10px">
        Categorias
      </Text>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {subcategoriesOptions.map((s, i) => (
          <FilterChip key={i} label={s.name} isActive={subcategories.includes(s.param)} onClick={() => toggle(s.param)} />
        ))}
      </Grid>
    </>
  );
}
